export default __webpack_public_path__ + "maps-examples-building-extrusions-thumbnail-480-b9ea38bfe0ac490c2240ca6af9acc594.png";